import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xDC32ce73f6Ff2f784c0c1Ab8a212eC9151f21179', // TODO
  [ChainId.BSCTESTNET]: '0xDC32ce73f6Ff2f784c0c1Ab8a212eC9151f21179',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
